import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SliderWrapper from 'jd-library/SliderWrapper';
import styles from './scss/view-file-details-slider.scss';
import useInfiniteScroll from 'jd-library/useInfiniteScroll';
import historyHandler from 'jd-library/historyHandler';

const ViewFileDetailsSlider = props => {
    const [files, setFiles] = useState(() => props.fileAttachmentArr.slice(0,20));
    const [sliderContRef, setSliderContRef] = useState();
    
    const sliderWrapProps = {
		header: {
                heading: 'Upload History',
                className: `${styles['view-details-files-header']}`,
                rightIcons: [
                    {
                        className: 'icon-HDRcross',
                        onClick: () => {
                            historyHandler.closeAll();
                        }
                    }
                ],
                leftIcons: props.isBrochure ? [] : [
                    {
                        className: 'icon-HDRback',
                        onClick: () => {
                            historyHandler.closeCurrent();
                        }
                    }
                ]
			},
          slider: {
               className: `${styles['view-details-files-slider']}`
          },
		onHidden: () => {
			props.closeSlider();
		},
        updateScrollContRef:ref => {
            setSliderContRef(ref);
        },
    };

    useEffect(() => {
        const len = files.length < 20 && props.fileAttachmentArr.length >= files.length ? 20 : files.length;
        setFiles(() => props.fileAttachmentArr.slice(0, len));
    },[props.fileAttachmentArr])    

    const [isFetching, setIsFetching] = useInfiniteScroll({
        loadMoreCB: () => {
            if(files.length < props.fileAttachmentArr.length){
                const len = files.length + 20 < props.fileAttachmentArr.length ? files.length + 20 : props.fileAttachmentArr.length; 
                setFiles(() => props.fileAttachmentArr.slice(0,len));
            }
            if (isFetching){
                setIsFetching(false);
            }
        },
        scrollContainer: sliderContRef,
		useWindow: false,
		threshold: 100,
		deps: [sliderContRef]
    })

    const getFilesList = () => {
        let filesList = [];
        files.forEach(item => {
               let errorMsg = '';
               let fileName = item.fileName + '.' + item.ext;
               if(item.isFileLimitError){
                   errorMsg = 'Max 5 Files Allowed';
                }else if(item.isFileSizeError){
                    errorMsg = 'File Size Cannot Exceed 25MB';
                }else if(item.uploaded === undefined){
                   errorMsg = '.'+item.ext + ' File Format Isn\'t Supported';
               }
               if(!item.isPreviouslyUploaded && (!props.fromFileModule || item.ext != 'WWW')){
                    filesList.push(
                        <div className={styles['file-name-main']}>
                            {item.uploaded ?
                            <div className={'icon-Checkmark'}></div>
                            :
                            <div className={'icon-alert_outline2'}></div>
                            } 
                            <div className={styles['file-name-status']}>
                                <div className={styles['file-name']}>{fileName}</div>
                                {item.uploaded ?
                                <div className={styles['file-status']}>Uploaded </div>
                                :
                                <div className={styles['error-msg']}>{item.erroMsg ? item.erroMsg : errorMsg}</div>
                                }
                            </div>    
                        </div>
                    );
               }
        });

        return filesList;
    }

    const WrapperElement = props.fromFileModule ? React.Fragment : SliderWrapper
    return(
        <WrapperElement
            {...sliderWrapProps}
        >
          <div className={styles['details-files-slider-main']}>
                {getFilesList()}
          </div>
        </WrapperElement>    
    )
}

const mapStateToProps = (state,props) => {
	return {
		...props,
        fileAttachmentArr : props.fileAttachmentArr || state.products.allProducts[props.productId].fileAttachmentArr || []
	}
}
export default connect(mapStateToProps)(ViewFileDetailsSlider);

